export const chartFontSize = '16px';
export const CHART_HEIGHT = 500
